/**
 * Yadom Label Order Form — Tokyo Messy
 * Handles tab switching, file uploads, and editor integration.
 */
(function () {
  'use strict';

  var ACCEPTED = '.png,.jpg,.jpeg,.pdf,.ai,.psd';
  var MAX_SIZE_MB = 20;

  function init() {
    var ylf = document.getElementById('YadomLabelForm');
    if (!ylf) return;

    var productFormEl = document.querySelector('product-form');
    if (!productFormEl) return;

    var form = productFormEl.querySelector('form');
    if (!form) return;

    // --- Tab switching ---
    var tabs = ylf.querySelectorAll('.ylf__tab');
    var panels = ylf.querySelectorAll('.ylf__tab-panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('ylf__tab--active'); });
        panels.forEach(function (p) { p.style.display = 'none'; p.classList.remove('ylf__tab-panel--active'); });
        tab.classList.add('ylf__tab--active');
        var panel = document.getElementById('ylf-panel-' + tab.dataset.tab);
        if (panel) { panel.style.display = ''; panel.classList.add('ylf__tab-panel--active'); }
      });
    });

    // --- Hidden inputs inside product form ---
    var capInput = createFileInput('properties[蓋デザイン]', 'ylf-file-cap');
    var bodyInput = createFileInput('properties[ボディデザイン]', 'ylf-file-body');
    form.appendChild(capInput);
    form.appendChild(bodyInput);

    var notesHidden = document.createElement('input');
    notesHidden.type = 'hidden';
    notesHidden.name = 'properties[特記事項]';
    form.appendChild(notesHidden);

    var modeHidden = document.createElement('input');
    modeHidden.type = 'hidden';
    modeHidden.name = 'properties[入稿方法]';
    form.appendChild(modeHidden);

    var returnInput = document.createElement('input');
    returnInput.type = 'hidden';
    returnInput.name = 'return_to';
    returnInput.value = '/cart';
    form.appendChild(returnInput);

    form.setAttribute('enctype', 'multipart/form-data');

    // --- Submit handler ---
    form.addEventListener('submit', function (e) {
      var activeTab = ylf.querySelector('.ylf__tab--active');
      var mode = activeTab ? activeTab.dataset.tab : 'template';

      if (mode === 'template') {
        // Template upload mode
        modeHidden.value = 'テンプレート入稿';
        var notesEl = document.getElementById('ylf-notes');
        if (notesEl) notesHidden.value = notesEl.value;
        if (!notesHidden.value) notesHidden.disabled = true;

        if (!capInput.files.length && !bodyInput.files.length) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showError(true);
          return;
        }
        showError(false);
        e.stopImmediatePropagation();
        // Let form submit traditionally

      } else if (mode === 'easy-design') {
        // Easy design mode
        e.preventDefault();
        e.stopImmediatePropagation();

        modeHidden.value = 'かんたんデザイン';
        var easyNotes = document.getElementById('ylf-notes-easy');
        if (easyNotes) notesHidden.value = easyNotes.value;
        if (!notesHidden.value) notesHidden.disabled = true;

        if (!window.YadomLabelEditor) {
          alert('エディタの読み込みに失敗しました。ページをリロードしてください。');
          return;
        }

        window.YadomLabelEditor.exportBoth().then(function (files) {
          if (!files.cap && !files.body) {
            alert('蓋またはボディのデザインを作成してください。');
            return;
          }
          if (files.cap) {
            var dt = new DataTransfer();
            dt.items.add(files.cap);
            capInput.files = dt.files;
          }
          if (files.body) {
            var dt2 = new DataTransfer();
            dt2.items.add(files.body);
            bodyInput.files = dt2.files;
          }
          form.submit();
        });
      }
    }, true);

    // --- File upload areas (template tab) ---
    setupUploadArea('cap', capInput);
    setupUploadArea('body', bodyInput);
  }

  function createFileInput(name, id) {
    var input = document.createElement('input');
    input.type = 'file';
    input.name = name;
    input.id = id;
    input.accept = ACCEPTED;
    input.style.display = 'none';
    return input;
  }

  function setupUploadArea(key, fileInput) {
    var area = document.getElementById('ylf-drop-' + key);
    var placeholder = document.getElementById('ylf-placeholder-' + key);
    var preview = document.getElementById('ylf-preview-' + key);
    var previewImg = document.getElementById('ylf-preview-img-' + key);
    var filename = document.getElementById('ylf-filename-' + key);
    if (!area || !placeholder || !preview) return;

    area.addEventListener('click', function (e) {
      if (e.target.closest('.ylf__upload-remove')) return;
      if (area.classList.contains('ylf--has-file')) return;
      fileInput.click();
    });

    fileInput.addEventListener('change', function () {
      if (fileInput.files.length > 0) {
        handleFile(fileInput.files[0], key, area, placeholder, preview, previewImg, filename);
      }
    });

    area.addEventListener('dragover', function (e) { e.preventDefault(); area.classList.add('ylf--dragover'); });
    area.addEventListener('dragleave', function () { area.classList.remove('ylf--dragover'); });
    area.addEventListener('drop', function (e) {
      e.preventDefault();
      area.classList.remove('ylf--dragover');
      if (e.dataTransfer.files.length > 0) {
        var dt = new DataTransfer();
        dt.items.add(e.dataTransfer.files[0]);
        fileInput.files = dt.files;
        handleFile(e.dataTransfer.files[0], key, area, placeholder, preview, previewImg, filename);
      }
    });

    var removeBtn = area.querySelector('.ylf__upload-remove');
    if (removeBtn) {
      removeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        fileInput.value = '';
        area.classList.remove('ylf--has-file');
        preview.style.display = 'none';
        placeholder.style.display = '';
        showError(false);
      });
    }
  }

  function handleFile(file, key, area, placeholder, preview, previewImg, filenameEl) {
    if (file.size > MAX_SIZE_MB * 1024 * 1024) {
      alert('ファイルサイズが' + MAX_SIZE_MB + 'MBを超えています。');
      return;
    }
    var ext = file.name.split('.').pop().toLowerCase();
    var allowed = ACCEPTED.replace(/\./g, '').split(',');
    if (allowed.indexOf(ext) === -1) {
      alert('対応していないファイル形式です。\n対応形式: ' + ACCEPTED);
      return;
    }

    area.classList.add('ylf--has-file');
    area.classList.remove('ylf--error');
    placeholder.style.display = 'none';
    preview.style.display = '';
    filenameEl.textContent = file.name;

    var isImage = /^(png|jpg|jpeg)$/.test(ext);
    if (isImage) {
      previewImg.style.display = '';
      var reader = new FileReader();
      reader.onload = function (e) { previewImg.src = e.target.result; };
      reader.readAsDataURL(file);
      var iconEl = preview.querySelector('.ylf__upload-file-icon');
      if (iconEl) iconEl.remove();
    } else {
      previewImg.style.display = 'none';
      var existing = preview.querySelector('.ylf__upload-file-icon');
      if (existing) existing.remove();
      var icon = document.createElement('div');
      icon.className = 'ylf__upload-file-icon';
      icon.innerHTML =
        '<svg width="36" height="36" viewBox="0 0 24 24" fill="none">' +
        '<path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="#000" stroke-width="1.5"/>' +
        '<path d="M14 2v6h6" stroke="#000" stroke-width="1.5"/></svg>' +
        '<span class="ylf__upload-file-ext">.' + ext + '</span>';
      preview.insertBefore(icon, filenameEl);
    }
    showError(false);
  }

  function showError(show) {
    var capArea = document.getElementById('ylf-drop-cap');
    var bodyArea = document.getElementById('ylf-drop-body');
    var errorMsg = document.getElementById('ylf-error-msg');

    if (show) {
      if (capArea && !capArea.classList.contains('ylf--has-file')) capArea.classList.add('ylf--error');
      if (bodyArea && !bodyArea.classList.contains('ylf--has-file')) bodyArea.classList.add('ylf--error');
      if (!errorMsg) {
        var row = document.querySelector('.ylf__upload-row');
        if (row) {
          errorMsg = document.createElement('p');
          errorMsg.id = 'ylf-error-msg';
          errorMsg.className = 'ylf__error-msg ylf--visible';
          errorMsg.textContent = 'デザインファイルをアップロードしてください';
          row.parentNode.insertBefore(errorMsg, row.nextSibling);
        }
      } else {
        errorMsg.classList.add('ylf--visible');
      }
    } else {
      if (capArea) capArea.classList.remove('ylf--error');
      if (bodyArea) bodyArea.classList.remove('ylf--error');
      if (errorMsg) errorMsg.classList.remove('ylf--visible');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
